import type { ReactElement } from 'react'
import styled from 'styled-components'

import type { TooltipRow } from './canvasTypes'

const Details = styled.dl`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin: 0.625rem 0 0;
`
const Row = styled.div<{ $stacked: boolean }>`
  display: grid;
  grid-template-columns: ${({ $stacked }): string =>
    $stacked ? 'minmax(0, 1fr)' : 'minmax(0, 2fr) minmax(0, 3fr)'};
  gap: 0.125rem 0.75rem;
  min-width: 0;
  dt {
    min-width: 0;
    color: var(--muted-foreground);
    overflow-wrap: break-word;
  }
  dd {
    min-width: 0;
    margin: 0;
    line-height: 1.45;
    overflow-wrap: anywhere;
  }
`

export function GraphSummaryDetails({
  rows,
}: {
  rows: TooltipRow[]
}): ReactElement {
  return (
    <Details>
      {rows.map((row) => (
        <Row
          key={row.label}
          $stacked={row.label === 'Description' || row.value.length > 100}>
          <dt>{row.label}</dt>
          <dd>{row.value}</dd>
        </Row>
      ))}
    </Details>
  )
}
